<template>
<div class="page-top animated fadeInDown">
  <transition name="fade" mode="out-in">
  <!-- <span class="search-box" v-show="isShow">
    <input type="text" v-model="searchParam.param" class="input" placeholder="搜索..." maxlength="30" autocomplete="off">
    <i class="icon-search search" @click="query()"></i>
  </span> -->
  </transition>
  <div class="nav">
    <div style="float:left">
      <img src="../../../assets/eslogo.png" style="width:120px;height: 26px;margin-right:20px;">
    </div>
    <div style="float:left">
      <li>
        <router-link tag="a" to="/index">
          <span class="tab-link">首页</span>
        </router-link>
      </li>
      <li>
        <router-link tag="a" to="/new">
          <span class="tab-link">更新</span>
        </router-link>
      </li>
      <li>
        <router-link tag="a" to="/rank">
          <span class="tab-link">排行</span>
        </router-link>
      </li>
      <li>
        <router-link tag="a" to="/category">
          <span class="tab-link">分类</span>
        </router-link>
      </li>
      <li>
        <router-link tag="a" to="/fee">
          <span class="tab-link">限免</span>
        </router-link>
      </li>
      <!-- <li>
        <a style="cursor:pointer" class="tab-link" @click="toggleShow()">搜索</a>
      </li> -->
    </div>
  </div>
  <div class="information">
        <div v-if="this.isYouke" class="youke">
          <div class="avatar">
            <img src="../../../assets/user.png">
          </div>
          <p class="base-info">
            <a @click="go('/login')" class="nickname">游客</a>
            <a @click="go('/login')" class="user-logout">登录</a>
            <a @click="go('/getPassword')" class="user-getPsd">找回密码</a>
          </p>
        </div>
        <div v-if="this.isUser" class="youke">
          <div class="avatar">
            <img src="../../../assets/user.png"  @click="go('/myInfo')" alt="进入主页" title="进入主页" >
          </div>
          <p class="base-info">
            <a class="nickname" alt="进入主页" title="进入主页"  @click="go('/myInfo')">{{userName}}<img src="../../../assets/viplg.jpg" v-if="this.isVip" class="vipLogo"></a>
            <a class="deadTime"  @click="go('/myInfo')" alt="进入主页" title="进入主页" v-if="this.isVip">到期时间：{{deadline}}</a>
            <a @click="go('/charge')" class="user-logout">充值</a>
            <a @click="logout()">退出</a>
          </p>
        </div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import {mapMutations, mapGetters} from 'vuex'
export default {
  data () {
    return {
      userName:"",
      isYouke:true,
      isUser:false,
      searchParam: {},
      isVip:false,
      deadline:""
    }
  },
  methods: {
    ...mapMutations({
      setUser: 'SET_USER',
      setParam: 'SET_PARAM',
      setIsShow: 'SET_ISSHOW'
    }),

    go (path) {
      this.$router.push(path)
    },
    logout () {
      var _this = this;
		  this.$confirm('确认退出吗?', '提示', {type: 'warning'}).then(() => {
		    console.log("退出！");
		    sessionStorage.removeItem('u');
        _this.isYouke = true;
        _this.isUser = false;
		    /*
        _this.setUser(null)
        _this.userName = "";
        _this.isYouke = true;
        _this.isUser = false;
        _this.isVip = fasle;
        _this.deadline = "";
		     */
        _this.$router.push('/');
      }).catch(() => {})
    },
    charge(){
      this.$router.push('/charge')
    }
  },
  created () {
    console.log("navBar钩子函数111");
    if(sessionStorage.getItem('u') != null ){
      this.setUser(JSON.parse(sessionStorage.getItem('u')));
      this.userName = (JSON.parse(sessionStorage.getItem('u')).userName);
      this.isVip = (JSON.parse(sessionStorage.getItem('u')).isVip);
      this.deadline = (JSON.parse(sessionStorage.getItem('u')).deadline);
    }
    if(sessionStorage.getItem('u') != null){
      this.isYouke = false;
      this.isUser = true;
    }
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.setIsShow(false)
      }
    })
  },
  mounted(){
    console.log("navBar钩子函数");

  },
  computed: {
    ...mapGetters([
      'user',
      'isShow'
    ]),
    f1()
    {return this.$store.state.user}

  },
  watch:{
    f1(curVal,oldVal){
      if(curVal.isVip==0){
        this.isVip = false;
      } else{
        this.isVip = true;
      }
      if(curVal.userName != null){
        this.isYouke = false;
        this.isUser = true;
        this.userName  = curVal.userName;
        this.deadline = curVal.deadline;
      } else{
        this.isYouke = true;
        this.isUser = false;
        this.userName = "";
        this.deadline = "";
      }
    }
  }
}
</script>

<style scoped lang="stylus" rle="stylesheet/stylus">
@import "~common/stylus/variable"
.page-top
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
  opacity 0.95
  width 100%
  position fixed
  right 0
  z-index 3
  background-color #fff
  height 60px
  .nav
    list-style none
    padding 20px 30px
    float left
    font-size $font-size-sm
    li
      position relative
      display initial
      padding-right 20px
    a
      color #5A5A5A
      text-decoration none
      font-size 15px
      -webkit-transition all .30s linear
      -moz-transition all .30s linear
      -o-transition all .30s linear
      -ms-transition all .30s linear
      transition all .30s linear
    a:hover
      color #fd113a
  .information
    float right
    padding-right 11px
    .login
      float right
      margin-top 20px
      right 2px
      font-size 13px
    .dropd
      .avatar
        float right
        margin-top 12px
        right 2px
        img
          width 32px
          height 32px
          border-radius 30px
        .dropme
          top 50px
          width 330px
          height 120px
          background-color #ffffcc
          .youke
            position relative
            height 50px
            padding 10px
            display none
            margin 0
            text-align left
            color #28292d
            font 12px/1.33333 'PingFang SC', 'Lantinghei SC', 'Microsoft Yahei', 'Hiragino Sans GB', 'Microsoft Sans Serif', 'WenQuanYi Micro Hei', sans-serif
            .base-info
              display block
              margin-block-start 1em
              margin-block-end 1em
              margin-inline-start 0px
              margin-inline-end 0px
              margin 0
              padding 0
              -webkit-tap-highlight-color rgba(0, 0, 0, 0)
              text-align left
              color #28292d
              font 12px/1.33333 'PingFang SC', 'Lantinghei SC', 'Microsoft Yahei', 'Hiragino Sans GB', 'Microsoft Sans Serif', 'WenQuanYi Micro Hei', sans-serif
              .nickname
                font-size 20px
                font-weight bold
                line-height 22px
                max-width 160px
                overflow hidden
                white-space nowrap
                text-overflow ellipsis
                margin-right 5px
                display inline-block
                text-decoration none
                color inherit
                text-align left
                cursor pointer
              .user-logout
                float right
                font-size 12px
                color #a28e83
                text-decoration none


    .back_btn
      float left
      padding-top 18px
      margin-right -10px
      -webkit-transition all .40s linear
      -moz-transition all .40s linear
      -o-transition all .40s linear
      -ms-transition all .40s linear
      transition all .40s linear
      cursor pointer
      li
        display initial
        padding-right 20px
    .back_btn:hover
      color #ff3860
  .search-box
    line-height 30px
    position absolute
    display inline-block
    width 60%
    margin-top: 14px
    left 20px
    max-width 100%
    height 30px
    padding 0
    border none
    z-index 11
    input
      font-size 14px
      line-height 30px
      position absolute
      top 0
      left 0
      width 100%
      height 30px
      padding 0 40px 0 18px
      border 1px solid #FFE1FF
      border-radius 20px
      outline 0
      color #6C7B8B
      background-color #fff
    input:hover
      border 1px solid #FFD1FF
    .search
      position relative
      margin 2px 0 0 3px
      float right
      color rgba(246, 71, 95, 0.4)
      font-size 22px
      right 12px
    .search:hover
      color $color-icon-mini

&.router-link-active
  .tab-link
    color red
    border-bottom 2px solid rgba(246, 71, 95,0.4)
    padding-bottom 18px
*, :after, :before
  -webkit-box-sizing border-box
  -moz-box-sizing border-box
  box-sizing border-box
@media screen and (max-width: 960px) {
  .page-top{
    width 100%
    }
}
.fade-enter-active, .fade-leave-active {
  transition opacity .6s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */ {
  opacity 0
}
  .user-getPsd{

  }
.tag{
  margin-left:10px;
  display: inline-block;
  font-size:12px;
  position:absolute;
}
</style>
<style type="text/css">
  .base-info a{
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }
  .base-info a.nickname:hover{
    color:#ff620e;
  }
  .base-info{
    display: inline-block;
  }
  .information .avatar{
    display: inline-block;
  }
  .youke{
    display: inline-block;
  }
  .information{
    height: 60px;
    line-height: 60px;
  }
  .information .avatar img{
    width: 20px;
    vertical-align: -6px;
    cursor: pointer;
  }
  .vipLogo{
    vertical-align: -4px;
  }
  .deadTime{
    font-size: 12px;
    font-weight: bolder;
  }
</style>



// WEBPACK FOOTER //
// src/view/base/navbar/navbar.vue